type TouchableProps = React.HTMLAttributes<HTMLDivElement>;

export const Touchable = ({ children, onClick, ...props }: TouchableProps) => (
  <div onClick={onClick} style={{ cursor: 'pointer' }} {...props}>
    {children}
  </div>
);
